import { render, staticRenderFns } from "./shopBasicInfoDetail.vue?vue&type=template&id=f4c0f5b6&"
import script from "./shopBasicInfoDetail.vue?vue&type=script&lang=js&"
export * from "./shopBasicInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopBasicInfoDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports